<template>
  <div>
    <VRow v-if="!isSmallScreen">
    <template v-for="(item, index) in toolbarItems">
      <VMenu
        v-if="item.subMenu"
        :key="index"
        :closeOnClick="true"
        :open-on-hover="!showOnClick"
        rounded="4"
        offset-y
        class="hidden-md-and-up"
      >
        <template #activator="{ on, attrs }">
          <VBtn
            v-blur
            light
            color="white"
            class="mx-2 shadow-none header__link body-1"
            exact
            exactActiveClass="active"

            v-bind="attrs"
            v-on="on"
          >
          <slot
            name="customLink"
            :item="item"
          >
            <span
              class="text-capitalize"
              :class="getCurrentPage === item.value ? 'body-bold' : 'body-1'"
            >{{ item.strapiText || $t(item.text) }}</span>
          </slot>
          </VBtn>
        </template>

        <VList
          nav
          dense
        >
          <VListItem
            v-for="(item, index) in item.subMenu"
            :key="index"
            :to="{ name: item.value }"
            exact
            class="header__link body-1"
            exactActiveClass="active"
          >
            <slot name="customLink">
              <VListItemTitle class="body-1">
                {{ item.strapiText || $t(item.text) }}
              </VListItemTitle>
            </slot>
          </VListItem>
        </VList>
      </VMenu>

      <VBtn
        v-else
        :key="`${item.text}_${index}`"
        class="mx-2 shadow-none header__link body-1"
        exact
        exactActiveClass="active"
        text
        :active="false"
        :to="{ name: item.value }"
      >
        <slot
          name="customLink"
          :item="item"
        >
          <span
            class="text-capitalize"
            :class="getCurrentPage === item.value ? 'body-bold' : 'body-1'"
          >{{ item.strapiText || $t(item.text) }}</span>
        </slot>
      </VBtn>

    </template>
    </VRow>
    <TheMobileMenu v-if="isSmallScreen" :toolbarItems="toolbarItems" />
  </div>
</template>
<script lang="ts">
export default {
  name: 'TheHeaderLinks',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import TheMobileMenu from '@slg/web-customer-shared/src/components/theHeader/theMobileMenu/TheMobileMenu.vue';
import { useRouteRef, useVuetify } from '../../../composables';

defineProps({
  toolbarItems: {
    type: Array,
    default: () => [],
    required: false,
  },
  showOnClick: {
    type: Boolean,
    default: false,
  },
});

const vuetify = useVuetify();
const route = useRouteRef();

const isSubMenuOpen = ref(false);
const isSmallScreen = computed(() => vuetify.breakpoint.smAndDown);
const getCurrentPage = computed(() => route.value.name);
</script>

<style scoped lang="scss">
@import "@slg/web-customer-shared/src/style/headerLinks.scss";
</style>
